import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalCheckbox,
  NormalInput,
} from "component/common";
import { withTranslation } from "react-i18next";
import {
  NewItemDivs,
  ItemDivs,
  updateCommon,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";

export default class EditdivisionCLass extends Component {
  state = {
    itemId: null,
    desc: null,
    checked: true,
  };

  componentDidMount = () => {
    let { itemId } = this.state;
    itemId = window.location.pathname.split("/")[4];
    this.setState({ itemId });
    this.listofdivision(itemId);
  };

  /* List of Division */
  listofdivision = async (code) => {
    let { desc, checked, temp } = this.state;
    await this.props.ItemDivs().then((res) => {
      let objIndex = res.findIndex((obj) => obj.itmCode == code);
      temp = res[objIndex];
      this.setState({
        temp,
      });
      desc = temp.itmDesc;
      checked = temp.itmIsactive;
      this.setState({
        desc,
        checked,
      });
    });
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  Addnewdivision = async () => {
    let { code, desc, checked } = this.state;
    if (desc == null) {
      Toast({
        type: "error",
        message: "Please check required field",
      });
    } else {
      let newdivision = {
        itmCode: this.state.itemId,
        itmDesc: desc,
        itmIsactive: checked,
        itmSeq: null,
      };
      await this.props
        .updateCommon(
          `ItemDivs/update?where=%7B%22itmCode%22%3A%20%22${this.state.itemId}%22%7D`,newdivision)
        .then((data) => {
          Toast({
            type: "success",
            message: "Updated Successfully",
          });
          desc = "";
          this.setState({ code, desc });
          this.props.history.push(
            `/admin/backend/itemclassification/division`
          )
        })
        .catch((e) => console.log(e));
    }
  };

  temp = ({ target: { value, name } }) => {
    let { code, desc, checked } = this.state;
    if (name == "code") {
      code = value;
      this.setState({ code });
    }
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
  };
  render() {
    let { t } = this.props;
    let { itemId, desc, checked } = this.state;
    return (
      <div className="bg-white">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 mt-3">
              <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                {t("Division List")}
              </h4>
            </div>
          </div>
          <div className="d-md-flex mt-3">
            <div className="col-12 col-md-6">
              <span>Code</span>
              <span style={{ color: "red" }}>*</span>
              <NormalInput
                value={itemId}
                name="code"
                onChange={this.temp}
                type="number"
                disabled={true}
              />
            </div>
            <div className="col-12 col-md-6">
              <span>Description</span>
              <span style={{ color: "red" }}>*</span>
              <NormalInput value={desc} name="desc" onChange={this.temp} />
            </div>
          </div>
          <div className="d-flex mt-4 ml-3">
            <NormalCheckbox
              checked={checked}
              name="checked"
              onChange={this.temp}
            />
            <p>{t("Active")}</p>
          </div>
          <div className="mt-3 col-12 col-md-2">
            <NormalButtonBackend
              mainbg={true}
              label={"UPDATE"}
              onClick={() => this.Addnewdivision()}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
    NewItemDivs,
      ItemDivs,
      updateCommon,
    },
    dispatch
  );
};

export const Editdivision = withTranslation()(
  connect(null, mapDispatchToProps)(EditdivisionCLass)
);
